export default () => {
    return `
        <div id="totop"></div>
        
        <header id="site_header"></header>
        <div class="header__overlay d-none"></div>
        <div class="container" id="site_content"></div>
        <div class="footer__outer" id="site_footer"></div>
            <div class="scrolltop-console">
                <div id="log_scrollTop"></div>
                <div id="log_midscreen"></div>
                <div id="scrollstate"></div>
                <div id="scrollstate2"></div>
                <div id="scrollstate3"></div>
                <div id="scrollstate4"></div>
                <div id="scrollstate5"></div>
                <div id="scrollstate6"></div>
            </div>
        <div id="redline"></div>
        <div id="blueline"></div>
        `;
}
